// Paid-traffic landing pages, split tested natively by Google Ads.
// Variants: a = no form (CTA links out), b = full embedded form, c = shortened form
// whose omitted fields post the literal "hidden" sentinel so leads are distinguishable
// from genuinely empty ones.

export const LP_CONCEPTS = ['long-copy', 'book-demo', 'free-account'] as const;
export type LpConcept = (typeof LP_CONCEPTS)[number];

export type LpVariant = 'a' | 'b' | 'c';

export type Lander = {
    slug: string;
    concept: LpConcept;
    variant: LpVariant;
    title: string;
    description: string;
};

export const LANDERS: Lander[] = [
    {
        slug: 'long-copy-a',
        concept: 'long-copy',
        variant: 'a',
        title: 'Adbeat — The Competitive Intelligence Platform for Display Advertisers',
        description:
            "Every ad your competitor runs is a clue. Adbeat hands you the whole case file — creatives, networks, publishers and estimated spend.",
    },
    {
        slug: 'long-copy-b',
        concept: 'long-copy',
        variant: 'b',
        title: 'Adbeat — The Competitive Intelligence Platform for Display Advertisers',
        description:
            "Every ad your competitor runs is a clue. Adbeat hands you the whole case file — creatives, networks, publishers and estimated spend.",
    },
    {
        slug: 'long-copy-c',
        concept: 'long-copy',
        variant: 'c',
        title: 'Adbeat — The Competitive Intelligence Platform for Display Advertisers',
        description:
            "Every ad your competitor runs is a clue. Adbeat hands you the whole case file — creatives, networks, publishers and estimated spend.",
    },
    {
        slug: 'book-demo-a',
        concept: 'book-demo',
        variant: 'a',
        title: 'Adbeat — See What Your Competitors Are Advertising',
        description:
            'Adbeat tracks display, native and programmatic ads across 145 ad networks in 35 countries. Book a live demo.',
    },
    {
        slug: 'book-demo-b',
        concept: 'book-demo',
        variant: 'b',
        title: 'Adbeat — See What Your Competitors Are Advertising',
        description:
            'Adbeat tracks display, native and programmatic ads across 145 ad networks in 35 countries. Book a live demo.',
    },
    {
        slug: 'book-demo-c',
        concept: 'book-demo',
        variant: 'c',
        title: 'Adbeat — See What Your Competitors Are Advertising',
        description:
            'Adbeat tracks display, native and programmatic ads across 145 ad networks in 35 countries. Book a live demo.',
    },
    {
        slug: 'free-account-a',
        concept: 'free-account',
        variant: 'a',
        title: 'Adbeat — See the Ads Your Competitors Run',
        description:
            "See the ads your competitors run — and their estimated ad spend. Start free, upgrade when the data pays for itself.",
    },
    {
        slug: 'free-account-b',
        concept: 'free-account',
        variant: 'b',
        title: 'Adbeat — See the Ads Your Competitors Run',
        description:
            "See the ads your competitors run — and their estimated ad spend. Start free, upgrade when the data pays for itself.",
    },
];

export const LP_SLUGS = LANDERS.map((l) => l.slug);

export function getLander(slug: string): Lander | undefined {
    return LANDERS.find((l) => l.slug === slug);
}

/** The "hidden" sentinel is only accepted from shortened (`c`) forms. */
export function allowsHiddenSentinel(slug: string): boolean {
    return getLander(slug)?.variant === 'c';
}

/**
 * The global free-signup modal is hidden on landers that embed their own form, so the two
 * don't compete. free-account-a deliberately has no on-page form, so the modal *is* its CTA.
 */
export function lpHidesFreeModal(pathname: string): boolean {
    const match = /^\/lp\/([^/]+)/.exec(pathname);
    if (!match) return false;
    const lander = getLander(match[1]);
    return !(lander?.concept === 'free-account' && lander.variant === 'a');
}

export const HIDDEN_SENTINEL = 'hidden';
